import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router";
import * as yup from "yup";
import {
  AlertInfo,
  ContentStyle,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import useFetch from "../../CustomHooks/useFetch";
import {
  DefaultPhysicianDropDownList,
  SetDefaultPhysician,
} from "../../Apis/AuthApiServices";
import { useState } from "react";
import YSSnackBar from "../../uikit/YSSnackBar";
import { DRxSelect2 } from "../../uikit/DRxSelect2";
import { useDispatch } from "react-redux";
import { loadingPatientDetails } from "../../Redux/Slice/PatientDetailsSlice";

export default function DefaultPhysician() {
  const dispatch = useDispatch();
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const doctorId: any = localStorage.getItem("doctorId");
  const patientId: any = sessionStorage.getItem("patientId");
  let Params = {
    doctorId: doctorId,
    patientId: patientId,
  };
  const { data, loading }: any = useFetch(
    Params,
    DefaultPhysicianDropDownList,
    []
  );
  const defaultPhysicianListOptions = data[0]?.defaultPhysicianList?.map(
    (item: any) => ({ label: item?.physicianName, value: item?.physicianId })
  ) ?? [{ value: "", label: "" }];
  const navigate = useNavigate();

  const setDefaultPhysician = async (values: any) => {
    try {
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("patientId", patientId);
      params.append("defaultPhysicianId", values.DefaultPhysician);

      const result = await SetDefaultPhysician(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        // dispatch(loadingPrescriberDetails());
        dispatch(loadingPatientDetails());
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Default Physician{" "}
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  Patients can be assigned with a default Physician here in this
                  section.
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Grid
            container
            item
            xs={12}
            spacing={3}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12}>
              <AlertInfo className="gray ni">
                <Typography
                  variant="body2"
                  component="div"
                  textAlign={"center"}
                >
                  Please Select the default physician for the patient
                </Typography>
              </AlertInfo>
            </Grid>
            <Grid item xs={12}>
              <Formik
                initialValues={{
                  DefaultPhysician: data[0]?.defaultPhysicianId ?? "",
                }}
                enableReinitialize={true}
                validationSchema={yup.object().shape({
                  DefaultPhysician: yup
                    .string()
                    .required("Default Physician is Required!"),
                })}
                onSubmit={(values) => {
                  setDefaultPhysician(values);
                }}
              >
                {(registerProps) => (
                  <Form onSubmit={registerProps.handleSubmit}>
                    <Grid
                      container
                      xs={12}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item xs={12} md={8}>
                        <InputSMBoxStyle>
                          <Typography
                            component="label"
                            color={greyColor}
                            variant="body2"
                            htmlFor="physician"
                            marginRight={3}
                            minWidth={130}
                          >
                            Default Physician
                            <Typography
                              component="span"
                              color={"error"}
                              variant="body2"
                            >
                              *
                            </Typography>
                          </Typography>{" "}
                          <Box>
                            <DRxSelectStyle>
                              <DRxSelect2
                                name="DefaultPhysician"
                                id="physician"
                                options={defaultPhysicianListOptions}
                                dataTestId="physician"
                                label="Default Physician"
                                value={registerProps.values.DefaultPhysician}
                                onChange={(option: any, e: any) => {
                                  registerProps.setFieldValue(
                                    "DefaultPhysician",
                                    e.props.value
                                  );
                                }}
                              />{" "}
                            </DRxSelectStyle>
                          </Box>
                        </InputSMBoxStyle>
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <InputSMBoxStyle>
                          <Typography
                            component="label"
                            color={greyColor}
                            variant="body2"
                            htmlFor="physician"
                            marginRight={3}
                            minWidth={130}
                          ></Typography>{" "}
                          <Box>
                            <YSButton
                              onClick={() => {
                                navigate("/newrxpad");
                              }}
                              className=""
                              children={"Back to NewRx"}
                              size={"large"}
                              type="button"
                              color="primary"
                              variant="outlined"
                            />{" "}
                            <YSButton
                              onClick={null}
                              className=""
                              children={"Save"}
                              size={"large"}
                              type="submit"
                              color="primary"
                              variant="contained"
                            />
                          </Box>
                        </InputSMBoxStyle>{" "}
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        )}
      </ContentStyle>
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
